import { createContext } from 'react';
import { TblMasterMCQ0Set } from '../Interfaces/DataBase/MCQ';

const MCQContext = createContext<TblMasterMCQ0Set>({});

export default MCQContext;
